import { useState, useEffect } from 'react'
import { SelectionBox, SearchBox } from '../Components/InputBox'
import { PersonFrame } from '../Components/Frame'
import { extractAllPitcherData } from '../Utils/DataProcess'
import { extractPlayerList } from '../Utils/PlayerListProcess'
import { PlayerList } from '../Components/PlayerList'

const PersonPitcher = ({data, loading }) => {
  
  const [player, setPlayer] = useState('')
  const handleOnSelect = (e) => {
    setPlayer(e.target.value)
  }
  const handleOnClickName = (e) => {
    setPlayer(e.name)
  }
  const [pitcherData, setPitcherData] = useState({playerList: [], table: {}, graph: {}, global: {}, pbpData: {}, prGraph: {}})
  const [allPlayers, setAllPlayers] = useState({idMap:{}, names: [], ids: [],})
  const [search, setSearch] = useState('')

  useEffect(()=>{
    if (!loading) {
      setPitcherData(extractAllPitcherData(data[0].data, data[1].data, data[2].data))
      setAllPlayers(extractPlayerList('pitcher', data[3].data))
    }
  }, [loading])

  const filterOutSearchResult = (s, valid) => {
    if (s === '' || s[0] === undefined) return valid
    let output = []
    for (const i of valid) {
      if (i.includes(s)) output.push(i)
    }
    return output
  }

  return (
    <>
      <div className="wrapper">
        <div className='page_menu'>
          <div className='page_menu_title'>選手名稱</div>
          <div className='page_header_select'>
            <SelectionBox val={player} placeholder='請選擇' options={pitcherData.playerList} handleSelect={handleOnSelect} loading={loading} />
          </div>
          <div className='page_menu_searchbox'>
            <SearchBox placeholder='搜尋選手' onClick={(val)=>{setSearch(val)}} />
          </div>
          <div className='page_menu_back_block'>
            <button className='page_menu_back_button' onClick={()=>{setPlayer(''); setSearch('');}}>回點將錄</button>
          </div>
        </div>
        <div className='wrap setin'>
          <div className='person_score'>
            <div className='title_frame'>
              <div className='title'>投手個人</div>
            </div>
          </div>
        </div>
      </div>
      <div className='wrapper bg_gray'>
        {
          (player === '' || player[0] === undefined)?
          <PlayerList type='pitcher' allPlayers={allPlayers} validPlayers={filterOutSearchResult(search, pitcherData.playerList)} handleOnClick={handleOnClickName} />:
          <PersonFrame type='personPitcher' 
            data={pitcherData.table[player]} graphData={pitcherData.graph[player]} global={pitcherData.global} 
            plays={pitcherData.pbpData[player]} prGraph={pitcherData.prGraph[player]}
          />
        }
      </div>
    </>
  )
}

export default PersonPitcher